/**
 * Function is used to fetch cart Attributes.
 * @returns cartAttributes
 */
const getPreviousCartAttributes = async () => {
  let cartAttributes = {}
  try {
    let cartResponse = await fetch('/cart.js')
    if (!cartResponse.ok) {
      throw new Error('Error in Response')
    }
    let cartData = await cartResponse.json()
    const finalToken = cartData.token
    const firstPartLength = Math.min(finalToken.length, 7)
    const lastPartLength = Math.min(finalToken.length, 8)
    const cartToken =
      finalToken.slice(0, firstPartLength) + finalToken.slice(-lastPartLength)

    const utm = localStorage.getItem('utm')
    const utm_medium = localStorage.getItem('utm_medium')
    const utm_campaign = localStorage.getItem('utm_campaign');
    const utm_direct = localStorage.getItem('utm_direct');
    const utm_medium_direct = localStorage.getItem('utm_medium_direct');
    const utm_campaign_direct = localStorage.getItem('utm_campaign_direct');

    cartAttributes = {
      ...cartData.attributes,
      cart_token: cartToken,
      utm_source : utm || '',
      utm_medium: utm_medium || '',
      utm_campaign: utm_campaign || '',
      utm_source_direct: utm_direct || '',
      utm_medium_direct: utm_medium_direct || '',
      utm_campaign_direct: utm_campaign_direct || ''
    }
  } catch (error) {
    console.error(error)
  }
  return cartAttributes
}

/**
 * Function is used to update Smartbuy cart Attributes.
 */
const updateCartSmartbuyAttribute = async () => {
  try {
    let previousCartAttributes = await getPreviousCartAttributes()

    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    let raw = JSON.stringify({
      attributes: {
        ...previousCartAttributes,
        giftcard: '',
        paymentLockingPayload: JSON.stringify({
          mergeWithDefaultMethods: false,
          action: 'lock',
          paymentMethods: [
            {
              filterType: 'whitelist',
              cardType: 'DEBIT',
              cardIssuer: ['HDFC Bank'],
              specificCardFilters: [
                {
                  card_brand: null,
                  card_type: null,
                  card_bank: 'HDFC Bank',
                },
              ],
              paymentMethodType: 'CARD',
            },
            {
              filterType: 'whitelist',
              paymentMethod: ['PAYZAPP'],
              paymentMethodType: 'WALLET',
            },
          ],
          supportReordering: true,
        }),
        gatewayReferenceId: 'ccavenue',
      },
    })

    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }
    fetch('/cart/update.js', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // get expiry time of smartbuy cookie
        const expiryDateString = getCookieVal("utmsource_smartbuy").expires;
        document.cookie = `smartbuyUpdatedOnce=true|expires=${expiryDateString}; expires=${expiryDateString}; path=/`;

        return true // no error occured.
      })
      .catch((error) => console.error('error', error))
  } catch (error) {
    console.error(error);
  }
}

const updatePaymentGatewayAttribute = async () => {
  try {
    let previousCartAttributes = await getPreviousCartAttributes();

    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    let raw = JSON.stringify({
      attributes: {
        ...previousCartAttributes,
        paymentLockingPayload: '',
        gatewayReferenceId: 'razorpay',
      },
    })
    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }
    fetch('/cart/update.js', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        return true // no error occured.
      })
      .catch((error) => console.error('error', error))
  } catch (error) {
    console.error(error)
  }
}

/**
 * Function is used to remove Smartbuy cart Attributes.
 */
async function removeSmartBuyAttribute() {
  let previousCartAttributes = await getPreviousCartAttributes();

  let myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')

  let raw = JSON.stringify({
    attributes: {
      ...previousCartAttributes,
      paymentLockingPayload: '',
      gatewayReferenceId: 'razorpay',
    },
  })

  let requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  }

  fetch('/cart/update.js', requestOptions)
    .then((response) => response.json())
    .then((result) => {
      //console.log("result", result);
    })
    .catch((error) => console.error('error', error))
}

/**
 * clear Smartbuy Session Variable
 */
const clearSmartbuyCookieVariable = () => {
  deleteCookie('utmsource_smartbuy');
  deleteCookie('smartbuyUpdatedOnce');
}

/**
 * Function is called on opening of cart drawer
 * Function to enable smartbuy logic on cart drawer
 * Note: smartbuy cookie variables will be removed on Thankyou page after checkout.
 */
async function enableSmartbuyOnItems() {
  try {
    let cartItemsPresent = document.querySelector(
      '#CartDrawer-Form .custom-cart-item'
    )
    //remove gift voucher input
    if (cartItemsPresent) {
      let giftVoucherInput = document.querySelector(
        '#CartDrawer-Form .cart__gift-voucher'
      )

      if (giftVoucherInput) {
        giftVoucherInput.style.display = 'none'
      }
    }
    //only one time to be executed
    if (getCookieVal('smartbuyUpdatedOnce') == null) {
      // check if cart Items present,
      if (cartItemsPresent) {
        //check if cart token present
        let cartTokenAttribute = document.cookie
          .split(';')
          .filter((item) => item.includes('cart='))

        if (cartTokenAttribute.length != 0) {
          //update smartbuy Attribute
          let isRequestSuccessful = updateCartSmartbuyAttribute()

          if (isRequestSuccessful) {
            let cartDrawerElement = document.querySelector(
              '#CartDrawer .drawer__inner'
            )
            let isCustomer = cartDrawerElement.getAttribute('data-iscustomer')

            if (isCustomer.trim() == 'true') {
              //check if gift card added, delete them
              let discountBars = document.querySelectorAll('.gft-card')

              if (discountBars) {
                let overlay = document.querySelector(
                  '.custom-cartdrawer-overlay'
                )

                overlay.classList.remove('hidden')
                refundAllCards()
                checkIfDiscountExists()
              }
            }
          }
        }
      }
    }
  } catch (error) {
    console.error(error)
  }
}
